import * as _ from 'lodash';
import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {  Store } from '@ngrx/store';
import {  Subject } from 'rxjs';
import {  map, switchMap } from 'rxjs/operators';
import { interval } from 'rxjs';
import { SlideShowService } from '../../services/slide-show.service';
import { RouteReuseStrategyService } from 'app/router-wrapper/services/route-reuse-strategy-service/route-reuse-strategy-service.service';
import { LoadingService } from 'app/core/services/loading.service';
import { I18nPluralPipe } from '@angular/common';
import { AuthService } from 'app/router-wrapper/services/auth/auth.service';
import { ToastService } from 'app/toast/services/toast.service';


@Component({
  selector: 'app-silent-auction-slide-show',
  templateUrl: './silent-auction-slide-show.component.html',
  styleUrls: ['./silent-auction-slide-show.component.scss'],
  providers: [I18nPluralPipe]
})
export class SilentAuctionSlideShowComponent implements OnInit, OnDestroy, AfterViewInit {

  public takeUntilSubject = new Subject();
  public activitySubject = new Subject()

  //  auction_show/handle/home/ppid/31 
  public auctionId = ''
  public presetId = ''
  public auction = null;
  public options = null;
  public option = null;
  public bids = [];
  public timestamp = 0;
  public optionImages:any = [];
  public currentBid = 0;
  public auctionStatus = 0;
  public isShowError = false;

  public isShowPauseCounter = false
  public isShowCloseCounter = false


  public orgLogo = '';
  public orgName = ''

  public swiper:number = 0;
  public swiperIndex:number = 0;
  public swiperConfig:number = 0;

  public swiperClassList = {
    "col-md-6": false,
    "col-xl-7": false
  }

  public index = 0;
  public qrUrl = ''
  public optionUrl = ''
  public handle = ''

  public intervalSubs = null;
  public slideShowOptSubs:any = null;

  public showBidHistory = false;

  constructor(
    public store: Store,
    public router: Router,
    public route: ActivatedRoute,
    public slideShowService:SlideShowService,
    public cdr: ChangeDetectorRef,
    private routeReuseStrategyService: RouteReuseStrategyService,
    public loadingService: LoadingService,
    public authService: AuthService,
    public elementRef: ElementRef,
    public toastService: ToastService
  ) { }

  ngOnInit(): void {
    window['leftside'] = false;
    this.authService.track = false;

    this.routeReuseStrategyService.status = true;

    this.route.params.subscribe((params) =>{

        let payeeParams = {
          'handle': params.handle,
           "ppid" :   Number(params.ppid)
        }

        this.slideShowService.getPayee(payeeParams).subscribe((info:any)=>{

          window["Intercom"]('update', {"hide_default_launcher": true});
          this.orgLogo = info.logoUrl;
          this.orgName = info.name;

          this.auction = info.selectedCampaign;

          if(!this.auction){
            this.isShowError = true
            return;
          }

          this.auctionStatus = this.slideShowService.getAuctionStatus(info.selectedCampaign.campaignTypeData).status
          this.showBidHistory = info.selectedCampaign.campaignTypeData.showBidHistory;

          this.swiperClassList["col-md-6"] = this.showBidHistory;
          this.swiperClassList["col-xl-7"] = this.showBidHistory;

          this.auctionId = info.selectedCampaign.id;
          
          if (this.auction.campaignTypeData.auctionControlMethod === 1){
            this.isShowPauseCounter = true
          }else {
            this.isShowPauseCounter = false
          }
          
          let options = [...this.auction.campaignTypeData.presetOptions]
          this.options = [...this.auction.campaignTypeData.presetOptions]
          this.option = options[0];
          
          this.presetId = this.option.id;
          this.qrUrl = this.getQRUrl();
    
          this.getBidActivity()
          this.optionImages = this.getOptImgArr(this.option);

          this.swiperConfig = this.getSwiperConfigType();
          this.swiper = this.swiperIndex ++ % 2
    
          this.startSlideShow(options);
    

        })

      this.handle = params.handle;
      this.optionImages = [];
      this.loadingService.enabled = false
    });
  }


  ngAfterViewInit():void{
    const elementStyles = window['documentManager'].createElement('link');
    elementStyles.href = 'paybee-spa/styles.css?v=398';
    elementStyles.rel = 'stylesheet';
    window['$'](this.elementRef.nativeElement).append(elementStyles);

    window['$']('#header').hide()
    window['$']('#main').removeClass('side-nav-open')
    window["Intercom"]('update', {"hide_default_launcher": true});
  }

  startSlideShow(options){
    this.slideShowOptSubs = interval(15000).subscribe(()=>{
      this.index = (this.index + 1) % options.length; 
      let currentOpt = options[this.index];
      this.option = currentOpt
      this.optionImages = this.getOptImgArr(this.option)
      this.presetId = currentOpt.id
      this.qrUrl = this.getQRUrl()
      this.swiperConfig = this.getSwiperConfigType();
      this.swiper = this.swiperIndex ++ % 2
      this.getBidActivity()
    })
  }


  updateOptionCurrentBid(bids, options){
    let sortedBids = _.orderBy(bids, 'created', 'asc')
    if(sortedBids.length > 0){
      options.map((option)=>{
        sortedBids.forEach(bid => {
          if(option.id == bid.optionInfo.id){
            option.currentBid = bid.amount
          }
        });
        return option
      })
    }
  }

  getOptImg(option){
    return option.imageUrl ? option.imageUrl : "images/org_logo_default_v2.svg"
  }

  getOptImgArr(option){
    let optionImagesArr = []

    if(option.imageUrl){
      optionImagesArr.push(option.imageUrl)
    }else{
      optionImagesArr.push("images/org_logo_default_v2.svg")
    }

    if(option.additionalImages){
      optionImagesArr = [...optionImagesArr, ...option.additionalImages]
    }

    return _.map(optionImagesArr, image => {
      return {
        image,
        styles: {
          backgroundImage: `url('${image}'), url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAABCAQAAABeK7cBAAAADUlEQVR42mP8/5+BAQAHAwIAILjcJwAAAABJRU5ErkJggg==)`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'contain',
          backgroundPosition: 'center'
        }
      }
    });
  }

  getCorrectAmount(amount){
    return this.slideShowService.addCommasToNumber(amount)
  }

  toggleStatus(event){
    this.auctionStatus = this.slideShowService.getAuctionStatus(this.auction.campaignTypeData).status
  }

  getQRUrl(){
    if(this.auction.campaignTypeData.auctionType == 0 ){
      const url = `${ location.origin }/quickpay.html?handle=${ this.handle }&ppid=${ this.auction.intid }&itemId=${ this.presetId }`
      this.optionUrl = url
      return "api/qr/get?size=100" + "&url=" + encodeURIComponent(url)
    }

    if(this.auction.campaignTypeData.auctionType == 1 ){
      const url = window.location.protocol + "//" + window.location.hostname + "/@" + this.handle + "@" + this.auction.intid;
      this.optionUrl = url
      return "/api/pp_code?pp=" + this.auctionId;
    }

  }

  getTimeStamp(dateString){
    return new Date(dateString).getTime()
  }

  getBidActivity(){
    let bidParams:any = {
      "campaignId": this.auctionId,
      count: 10,
      'since':this.auction.created,
      "itemId":this.presetId
    }
    this.loadingService.enabled = false

    this.bids = [];

    this.slideShowService.getBidActivities(bidParams).pipe(
      map((bids:any)=>{
        this.updateOptionCurrentBid(bids,this.options)
        return bids.map(bid=>{
         const created = Math.round((new Date().getTime() -  this.getTimeStamp(bid.created))/1000)
          return {...bid, created}
        })
      })
    ).subscribe((bids:any) => {
      this.loadingService.enabled = true
      this.bids = _.uniqBy([...bids], bid =>bid.id)
      this.bids = this.bids.slice(0,5)
      this.loadingService.enabled = true

      if(bids.length > 1){
       let campaignTypeData =  bids[0].campaignData.campaignTypeData
       this.auctionStatus = this.slideShowService.getAuctionStatus(campaignTypeData).status
      }
     
    });

    if(this.intervalSubs){
      this.intervalSubs.unsubscribe();
    }

    this.intervalSubs = interval(2000).pipe(
        switchMap((paramss) => {
          this.loadingService.enabled = false
          this.timestamp = Math.round(Date.now() / 1000);
          return this.slideShowService.getBidActivities(bidParams);
        }), 
        map((bids:any)=>{
          this.updateOptionCurrentBid(bids,this.options)
          return bids.map(bid=>{
            const created = Math.round((new Date().getTime() -  this.getTimeStamp(bid.created))/1000)
            return {...bid, created}
          })
    })).subscribe((bids:any) => {
        this.loadingService.enabled = true
        this.bids = _.uniqBy([...bids,...this.bids], bid => bid.id)
        this.bids = this.bids.slice(0,5)

        if(bids.length > 1){
          let campaignTypeData =  bids[0].campaignData.campaignTypeData
          this.auctionStatus = this.slideShowService.getAuctionStatus(campaignTypeData).status
          }
    })
  }

  getSwiperConfigType(){
      if(this.optionImages.length >= 3){
        return 0;
      }else if(this.optionImages.length == 1){
        return 1;
      }else{
        return 0
      }
  }

  ngOnDestroy():void{
    window['leftside'] = true;
    this.authService.track = true;
    this.routeReuseStrategyService.status = false;
    window['$']('#header').show()
    window['$']('#main').addClass('side-nav-open')
    this.takeUntilSubject.next(null);
    this.takeUntilSubject.complete();
    window["Intercom"]('update', {"hide_default_launcher": false});
    this.slideShowOptSubs.unsubscribe()
    this.intervalSubs.unsubscribe()
  }

}
